export class Variedad {
  public variety_id: string;
  public species_id: string;
  public variety_name: string;
  public common_name: string;
  public synonyms: string;
  public meaning: string;
  public description: string;
  public description_quechua: string;
  public is_reviewed: string;
  public updated_by: string;
  public updated_at: string;
  public deleted_by: string;
  public deleted_at: string;
  public available: string;

  constructor(
    variety_id: string,
    species_id: string,
    variety_name: string,
    common_name: string,
    synonyms: string,
    meaning: string,
    description: string,
    description_quechua: string,
    is_reviewed: string,
    updated_by: string,
    updated_at: string,
    deleted_by: string,
    deleted_at: string,
    available: string
  ) {
    this.variety_id = variety_id;
    this.species_id = species_id;
    this.variety_name = variety_name;
    this.common_name = common_name;
    this.synonyms = synonyms;
    this.meaning = meaning;
    this.description = description;
    this.description_quechua = description_quechua;
    this.is_reviewed = is_reviewed;
    this.updated_by = updated_by;
    this.updated_at = updated_at;
    this.deleted_by = deleted_by;
    this.deleted_at = deleted_at;
    this.available = available;
  }
}
class group_A {
  public species_name: string;
  public ploidy: string;
  constructor(species_name: string, ploidy: string) {
    this.species_name = species_name;
    this.ploidy = ploidy;
  }
}
class group_B {
  public abundance: string;
  public relative_cultivar_frequency_value: string;
  public overall_cultivar_frequency_value: string;
  public overall_cultivar_frequency: string;
  constructor(
    abundance: string,
    relative_cultivar_frequency_value: string,
    overall_cultivar_frequency_value: string,
    overall_cultivar_frequency: string
  ) {
    this.abundance = abundance;
    this.relative_cultivar_frequency_value = relative_cultivar_frequency_value;
    this.overall_cultivar_frequency_value = overall_cultivar_frequency_value;
    this.overall_cultivar_frequency = overall_cultivar_frequency;
  }
}
class group_C {
  public description: string;
  public description_quechua: string;
  constructor(description: string, description_quechua: string) {
    this.description = description;
    this.description_quechua = description_quechua;
  }
}
class group_X {
  public variety_name: string;
  constructor(variety_name: string) {
    this.variety_name = variety_name;
  }
}
class group_Y {
  public synonyms: string;
  constructor(synonyms: string) {
    this.synonyms = synonyms;
  }
}
class group_Z {
  public meaning: string;
  constructor(meaning: string) {
    this.meaning = meaning;
  }
}
class descriptor_item {
  public descriptor_id: number;
  public descriptor_name: string;
  public value: string;
  constructor(descriptor_id: number, descriptor_name: string, value: string) {
    this.descriptor_id = descriptor_id;
    this.descriptor_name = descriptor_name;
    this.value = value;
  }
}
class descriptors_plant {
  public descriptor_plant_list: descriptor_item[];
  constructor(descriptor_plant_list: descriptor_item[]) {
    this.descriptor_plant_list = descriptor_plant_list;
  }
}
class descriptors_flower {
  public descriptor_flower_list: descriptor_item[];
  constructor(descriptor_flower_list: descriptor_item[]) {
    this.descriptor_flower_list = descriptor_flower_list;
  }
}
class descriptors_tuber {
  public descriptor_tuber_list: descriptor_item[];
  constructor(descriptor_tuber_list: descriptor_item[]) {
    this.descriptor_tuber_list = descriptor_tuber_list;
  }
}
class descriptors_agronomy {
  public descriptor_agronomy_list: descriptor_item[];
  constructor(descriptor_agronomy_list: descriptor_item[]) {
    this.descriptor_agronomy_list = descriptor_agronomy_list;
  }
}
class descriptors_post_harvest {
  public descriptor_post_harvest_list: descriptor_item[];
  constructor(descriptor_post_harvest_list: descriptor_item[]) {
    this.descriptor_post_harvest_list = descriptor_post_harvest_list;
  }
}
class descriptors_culinary {
  public descriptor_culinary_list: descriptor_item[];
  constructor(descriptor_culinary_list: descriptor_item[]) {
    this.descriptor_culinary_list = descriptor_culinary_list;
  }
}
export class RespCatalogInfo {
  public variety_id: string;
  public group_a: group_A;
  public group_b: group_B;
  public group_c: group_C;
  public group_x: group_X;
  public group_y: group_Y;
  public group_z: group_Z;
  public descriptors_plant: descriptors_plant;
  public descriptors_flower: descriptors_flower;
  public descriptors_tuber: descriptors_tuber;
  public descriptors_agronomy: descriptors_agronomy;
  public descriptors_post_harvest: descriptors_post_harvest;
  public descriptors_culinary: descriptors_culinary;
  constructor(
    variety_id: string,
    group_a: group_A,
    group_b: group_B,
    group_c: group_C,
    group_x: group_X,
    group_y: group_Y,
    group_z: group_Z,
    descriptors_plant: descriptors_plant,
    descriptors_flower: descriptors_flower,
    descriptors_tuber: descriptors_tuber,
    descriptors_agronomy: descriptors_agronomy,
    descriptors_post_harvest: descriptors_post_harvest,
    descriptors_culinary: descriptors_culinary
  ) {
    this.variety_id = variety_id;
    this.group_a = group_a;
    this.group_b = group_b;
    this.group_c = group_c;
    this.group_x = group_x;
    this.group_y = group_y;
    this.group_z = group_z;
    this.descriptors_plant = descriptors_plant;
    this.descriptors_flower = descriptors_flower;
    this.descriptors_tuber = descriptors_tuber;
    this.descriptors_agronomy = descriptors_agronomy;
    this.descriptors_post_harvest = descriptors_post_harvest;
    this.descriptors_culinary = descriptors_culinary;
  }
}
class pagination {
  public page: number;
  public page_size: number;
  public total_count: number;
  public total_pages: number;
  constructor(
    page: number,
    page_size: number,
    total_count: number,
    total_pages: number
  ) {
    this.page = page;
    this.page_size = page_size;
    this.total_count = total_count;
    this.total_pages = total_pages;
  }
}
export class RespSearch {
  public success: boolean;
  public pagination: pagination;
  public data: any[];
  public message: string;
  constructor(
    success: boolean,
    pagination: pagination,
    data: any[],
    message: string
  ) {
    this.success = success;
    this.pagination = pagination;
    this.data = data;
    this.message = message;
  }
}
export class VarietyFilter {
  public type: string;
  public descriptor_id?: number;
  public filter_value: string | number;

  constructor(
    type: string,
    descriptor_id: number,
    filter_value: string | number
  ) {
    this.type = type;
    this.descriptor_id = descriptor_id;
    this.filter_value = filter_value;
  }
}
export class RespObservationGps {
  public variety_observation_id: number;
  public latitude: number;
  public longitude: number;

  constructor(
    variety_observation_id: number,
    latitude: number,
    longitude: number
  ) {
    this.variety_observation_id = variety_observation_id;
    this.latitude = latitude;
    this.longitude = longitude;
  }
}
export class RespCountries {
  public success: boolean;
  public data: string[];
  constructor(success: boolean, data: string[]) {
    this.success = success;
    this.data = data;
  }
}
export class RespRegions {
  public success: boolean;
  public data: string[];
  constructor(success: boolean, data: string[]) {
    this.success = success;
    this.data = data;
  }
}
export class RespVarietalGroups {
  public success: boolean;
  public data: string[];
  constructor(success: boolean, data: string[]) {
    this.success = success;
    this.data = data;
  }
}
